// Global JavaScript for Watch Shop Theme

// Cart functionality
class CartManager {
  constructor() {
    this.cartCountElement = document.querySelector('[data-cart-count]');
    this.updateCartCount();
    this.bindEvents();
  }

  bindEvents() {
    // Update cart count when items are added
    document.addEventListener('cart:updated', () => {
      this.updateCartCount();
    });
  }

  async updateCartCount() {
    try {
      const response = await fetch(window.routes.cart_url + '.js');
      const cart = await response.json();
      if (this.cartCountElement) {
        this.cartCountElement.textContent = cart.item_count;
      }
    } catch (error) {
      console.error('Error updating cart count:', error);
    }
  }
}

// Product form submission
document.addEventListener('DOMContentLoaded', () => {
  const productForms = document.querySelectorAll('.product-card__form, form[action*="cart"]');
  
  productForms.forEach(form => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      
      const submitButton = form.querySelector('button[type="submit"]');
      const originalText = submitButton.textContent;
      const variantId = form.querySelector('input[name="id"]')?.value;

      // Validate variant ID
      if (!variantId) {
        alert('Product variant not available. Please refresh the page and try again.');
        return;
      }

      // Disable button and show loading state
      submitButton.disabled = true;
      submitButton.textContent = 'Adding...';

      try {
        // Get the cart add URL and ensure it's the JSON endpoint (.js)
        let cartAddUrl = form.action || (window.routes && window.routes.cart_add_url) || '/cart/add';
        
        // Convert to JSON endpoint if not already
        if (!cartAddUrl.endsWith('.js')) {
          cartAddUrl = cartAddUrl.replace(/\/cart\/add$/, '/cart/add.js');
        }
        
        // Create FormData from the form
        const formData = new FormData(form);
        
        // Ensure quantity is set (default to 1 if not present)
        if (!formData.has('quantity')) {
          formData.append('quantity', '1');
        }

        const response = await fetch(cartAddUrl, {
          method: 'POST',
          headers: {
            'Accept': 'application/json'
          },
          body: formData
        });

        if (response.ok) {
          const data = await response.json();
          submitButton.textContent = 'Added!';
          
          // Dispatch custom event for cart update
          document.dispatchEvent(new CustomEvent('cart:updated'));
          
          // Show success message
          console.log('Product added to cart', data);

          // Reset button after 2 seconds
          setTimeout(() => {
            submitButton.disabled = false;
            submitButton.textContent = originalText;
          }, 2000);
        } else {
          // Handle error response
          let errorMessage = 'Failed to add product to cart. Please try again.';
          
          try {
            const errorData = await response.json();
            if (errorData.description) {
              errorMessage = errorData.description;
            } else if (errorData.message) {
              errorMessage = errorData.message;
            }
          } catch (parseError) {
            // If response is not JSON, try to get text
            const responseText = await response.text();
            console.error('Cart API error response:', response.status, responseText);
          }
          
          throw new Error(errorMessage);
        }
      } catch (error) {
        console.error('Error adding to cart:', error);
        submitButton.disabled = false;
        submitButton.textContent = originalText;
        
        // Show user-friendly error message
        const errorMessage = error.message || 'Failed to add product to cart. Please try again.';
        alert(errorMessage);
      }
    });
  });

  // Initialize cart manager
  new CartManager();
});

// Smooth scroll for anchor links
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
    e.preventDefault();
    const target = document.querySelector(this.getAttribute('href'));
    if (target) {
      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  });
});

// Mobile menu toggle (if needed)
class MobileMenu {
  constructor() {
    this.menuButton = document.querySelector('.mobile-menu-button');
    this.menu = document.querySelector('.header__nav');
    
    if (this.menuButton && this.menu) {
      this.menuButton.addEventListener('click', () => {
        this.menu.classList.toggle('active');
        this.menuButton.classList.toggle('active');
      });
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new MobileMenu();
});

// Lazy loading images
if ('IntersectionObserver' in window) {
  const imageObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const img = entry.target;
        if (img.dataset.src) {
          img.src = img.dataset.src;
          img.removeAttribute('data-src');
          observer.unobserve(img);
        }
      }
    });
  });

  document.querySelectorAll('img[data-src]').forEach(img => {
    imageObserver.observe(img);
  });
}

// Cart page functionality
document.addEventListener('DOMContentLoaded', () => {
  // Quantity selector buttons
  const quantityButtons = document.querySelectorAll('.quantity-selector__button');
  quantityButtons.forEach(button => {
    button.addEventListener('click', (e) => {
      e.preventDefault();
      const key = button.dataset.key;
      const input = document.querySelector(`#quantity-${key}`);
      if (!input) return;

      let currentValue = parseInt(input.value) || 0;
      
      if (button.classList.contains('quantity-selector__button--plus')) {
        currentValue++;
      } else if (button.classList.contains('quantity-selector__button--minus')) {
        currentValue = Math.max(0, currentValue - 1);
      }

      input.value = currentValue;
      
      // Auto-update cart if quantity is 0
      if (currentValue === 0) {
        const removeLink = document.querySelector(`.cart-item__remove-link[data-key="${key}"]`);
        if (removeLink) {
          removeLink.click();
        }
      }
    });
  });

  // Cart item removal
  const removeLinks = document.querySelectorAll('.cart-item__remove-link');
  removeLinks.forEach(link => {
    link.addEventListener('click', async (e) => {
      e.preventDefault();
      
      if (confirm('Are you sure you want to remove this item from your cart?')) {
        const href = link.getAttribute('href');
        if (href) {
          window.location.href = href;
        }
      }
    });
  });

  // Auto-submit form on quantity change
  const quantityInputs = document.querySelectorAll('.quantity-selector__input');
  quantityInputs.forEach(input => {
    input.addEventListener('change', () => {
      const form = document.getElementById('cart-form');
      if (form) {
        // Small delay to allow user to see the change
        setTimeout(() => {
          form.submit();
        }, 500);
      }
    });
  });
});

